/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetAllMonthlyCoveragePlanStatusesParams,
  IReadOnlyListOfMonthlyCoveragePlanStatusDto,
  MonthlyCoveragePlanStatusDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all monthlycoverageplanstatus enumeration values, with an optional filter.
 */
export const getAllMonthlyCoveragePlanStatuses = (
    params?: GetAllMonthlyCoveragePlanStatusesParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfMonthlyCoveragePlanStatusDto>>,) => {
      return customInstance<IReadOnlyListOfMonthlyCoveragePlanStatusDto>(
      {url: `/deployment/monthly-coverage-plan-statuses`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the MonthlyCoveragePlanStatus identified by the route id.
 */
export const getMonthlyCoveragePlanStatusById = (
    id: number,
 options?: SecondParameter<typeof customInstance<MonthlyCoveragePlanStatusDto>>,) => {
      return customInstance<MonthlyCoveragePlanStatusDto>(
      {url: `/deployment/monthly-coverage-plan-statuses/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllMonthlyCoveragePlanStatusesResult = NonNullable<Awaited<ReturnType<typeof getAllMonthlyCoveragePlanStatuses>>>
export type GetMonthlyCoveragePlanStatusByIdResult = NonNullable<Awaited<ReturnType<typeof getMonthlyCoveragePlanStatusById>>>
